/* eslint-disable react/self-closing-comp */
import React from 'react';
import PropTypes from 'prop-types';
// 🧭 Navigation
// import { hashHistory } from 'react-router';
// Custom
import { FlowLogoImg } from 'components/img/AssetImg';
import { Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Link from 'components/core/Link';
import CpmClientNavRightList from './CpmClientNavRightList';

const useStyles = makeStyles((theme) => ({
  header: {
    padding: 'clamp(10px, 1.5vw, 30px)',
    borderBottom: '1px solid #F4F4F5',
  },
  toolbar: {
    backgroundColor: '#FFF',
    justifyContent: 'flex-start',
    padding: 0,
    gap: '5px',
  },
  gradientLine: {
    height: '7px' /* Thickness of the line */,
    background:
      'linear-gradient(90deg, rgba(122,56,191,1) 0%, rgba(12,179,228,1) 50%, rgba(4,36,156,1) 100%)' /* gradient colors */,
    /* Large devices (desktops, 992px and up) */
    display: 'none', // Default for mobile view
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
}));

// 🔵 Logo
const MIN_LOGO_WIDTH = '140px';
const MAX_LOGO_WIDTH = '220px';
const RESPONSIVE_LOGO_WIDTH = `clamp(${MIN_LOGO_WIDTH}, 20vw, ${MAX_LOGO_WIDTH})`;

const CpmClientHeader = ({ hideLogo, handleFormTypeChange }) => {
  const classes = useStyles();
  const GradientLine = <div className={classes.gradientLine}></div>;
  const Logo = !handleFormTypeChange ? (
    /* <a
      href="/my_bookings"
      onClick={(e) => {
        e.preventDefault();
        hashHistory.push('/my_bookings');
      }}
      style={{ width: RESPONSIVE_LOGO_WIDTH }}
    > */
    <a style={{ width: RESPONSIVE_LOGO_WIDTH }}>
      {FlowLogoImg('100%')}
    </a>
  ) : (
    <Link
      onClick={() => handleFormTypeChange('signin')}
      style={{ width: RESPONSIVE_LOGO_WIDTH }}
    >
      {FlowLogoImg('100%')}
    </Link>
  );

  return (
    <React.Fragment>
      <header className={classes.header}>
        <Toolbar className={classes.toolbar} position="static">
          { !hideLogo
            ? Logo
            : null}
          <CpmClientNavRightList />
        </Toolbar>
      </header>
      {GradientLine}
    </React.Fragment>
  );
};

CpmClientHeader.propTypes = {
  hideLogo: PropTypes.bool,
  handleFormTypeChange: PropTypes.func,
};

CpmClientHeader.defaultProps = {
  hideLogo: false,
  handleFormTypeChange: null,
};

module.exports = CpmClientHeader;



// WEBPACK FOOTER //
// ./components/header/CpmClientHeader.js